import React from "react";

import {Icon} from "semantic-ui-react";

import "./ToastNotification.css";


const ToastNotification = (props) =>
    <div className="barestho-toast-notification">
        <Icon name={props.iconName} size="large"/>{props.message}
    </div>;

export default ToastNotification;


// WEBPACK FOOTER //
// ./src/components/ToastNotification/ToastNotification.js